<div *ngIf="pokemon" class="row">
  <div class="col s12 m8 offset-m2">
  <h2 class="header center">{{ pokemon.name }}</h2>
  <div class="card horizontal hoverable">
    <div class="card-image">
      <img [src]="pokemon.picture">
    </div>
    <div class="card-stacked">
      <div class="card-content">
        <table class="bordered striped">
          <tbody>
            <tr>
              <td>Nom</td>
              <td><strong>{{ pokemon.name }}</strong></td>
            </tr>
            <tr>
              <td>Points de vie</td>
              <td><strong>{{ pokemon.hp }}</strong></td>
            </tr>
            <tr>
              <td>Dégâts</td>
              <td><strong>{{ pokemon.cp }}</strong></td>
            </tr>
            <tr>
              <td>Types</td>
              <td>
                <span *ngFor="let type of pokemon.types" class="{{ type | pokemonTypeColor }}">{{ type }}</span>
              </td>
            </tr>
            <tr>
              <td>Date de création</td>
              <td><em>{{ pokemon.created | date:"dd/MM/yyyy" }}</em></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-action">
        <a (click)="goBack()" class="return-list waves-effect waves-light btn">Retour</a>
        <a (click)="goEdit(pokemon)" class="edit-pokemon waves-effect waves-light btn">Editer</a>
        <a (click)="delete(pokemon)" class="delete-pokemon waves-effect waves-orange btn">Supprimer</a>
      </div>
    </div>
  </div>
  </div>
  </div>

  <h4 *ngIf='!pokemon' class='center'>
    <app-pokemon-loader></app-pokemon-loader>
  </h4>
